/* @flow */
import actionTypes from '../actions/types';

export type Curreny = {
  name: string,
  pair: string,
  symbol: string,
  rate?: number,
};

const CURRENY_MAP = [
  { name: 'CNY', symbol: '¥' },
  { name: 'EUR', symbol: '€' },
  { name: 'GBP', symbol: '£' },
  { name: 'JPY', symbol: '¥' },
  { name: 'KRW', symbol: '₩' },
  { name: 'RUB', symbol: '₽' },
  { name: 'USD', symbol: '$' },
  { name: 'INR', symbol: '₹' },
  { name: 'TRY', symbol: '₺' },
  { name: 'CAD', symbol: 'C$' },
  { name: 'IDR', symbol: 'Rp' },
  { name: 'AUD', symbol: 'A$' },
  { name: 'BRL', symbol: 'R$' },
];

export const INITIAL_STATE = {
  cnyUsdRate: 0,
  fiatRate: {},
  currencyList: CURRENY_MAP,
  baseConfigs: null
};

const onFetchCurrencySuccess = (data) => {
  const currencyList = [...data, { pair: 'USD_USD', symbol: '$', rate: 1 }];
  const pairObj = currencyList.map(item => {
    const pairs = item.pair.split('_');

    return {
      ...item,
      name: pairs[0],
      quote: pairs[1],
    };
  }).filter(v => v.quote === 'USD');

  return pairObj;
};

export const reducer = (state: any, action: any) => {
  switch (action.type) {
    case actionTypes.SET_EXCHANGE_INFO:
      return { ...state, info: action.data };
    case actionTypes.SET_HEADER_CONFIG:
      return {...state, baseConfigs: action.data}
    case actionTypes.SET_CURRENCY_RATE_DATA:
      return {
        ...state,
        currencyList: onFetchCurrencySuccess(action.data),
      };
    case actionTypes.SET_TO_FIAT_RATE:
      return { ...state, fiatRate: action.data };
    default:
      return state;
  }
};
